import { useMutation } from "react-query"
import { toast } from "react-toastify"
import { useUI } from "providers/UIProvider"

import reservationsService from "api/reservationsService"
import { IUpdateReservationWasherURLParams } from "types/reservation"
import { AxiosError } from "axios"

const useUpdateReservationWasherMutation = () => {
  const { T } = useUI()
  return useMutation(
    async (params: IUpdateReservationWasherURLParams) => {
      const res = await reservationsService.updateReservationWasher(params)

      return res.data
    },
    {
      onError: (err: AxiosError<any>) => {
        toast.error(T(`${err.response?.data.MessageId}`) || T("general.error"))
      },
    },
  )
}

export default useUpdateReservationWasherMutation
